import type { CSSProperties } from "react";
import { C } from "../tokens";

export const CHAT_INPUT_STYLE: CSSProperties = {
  width: "100%", maxWidth: 780, display: "flex", alignItems: "center",
  gap: 12, height: 62, padding: "0 9px 0 22px", borderRadius: 18,
  background: C.surface, border: `1px solid ${C.line}`,
  boxShadow: `0 1px 2px ${C.softShadow}, 0 6px 18px ${C.softShadowLow}`,
  font: "inherit",
};

export const CHAT_SEND_STYLE: CSSProperties = {
  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  width: 44, height: 44, padding: 0, borderRadius: 999, border: "none",
  background: C.ink, color: C.surface, cursor: "pointer",
};

export function ChatSendIcon() {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 19V5M5 12l7-7 7 7" />
  </svg>;
}
